<template lang="pug">
    .component-reservation-controller(v-if="item")
        statistics-card4
            .field-reporting-type(slot="n1")
                .field-type-name {{item.type.name}}
                .field-type-description {{item.type.description}}
            .field-reporting-status(slot="n2")
                .label Status
                .field-value {{item.status}}
            .field-reporting-location(slot="n3")
                .label Location
                .field-value {{item.location}}
            .field-reporting-timestamp(slot="n4")
                .field-value Created {{$dateFormat(item.created, "DD-MM-YYYY HH:mm:ss")}}
                .field-value Updated {{$dateFormat(item.updated, "DD-MM-YYYY HH:mm:ss")}}
        .row
            .columns.large-6.small-12
                .card
                    driver(:type="'driver-card'", :item="item.driver")
                vehicle(v-if="item.vehicle", :type="'compact-card'", :item="item.vehicle")
            .columns.large-6.small-12
                .card
                    .inner-content
                        p {{item.description}}
                        hr
                        vehicle-damage(v-if="item.damage_position_raw", :items="item.damage_position_raw", :vehicleType="item.vehicle.category.vehicle_type.name", :vehicleDamagePicture="item.vehicle.category.damage_picture_external")
                        h2 Attachments
                        backoffice-attachment(v-for="attachment in item.attachments", :item="attachment")
</template>
<script type="text/babel">
    import StatisticsCard4 from "components/structure/ui/StatisticsCard4";
    import KeplerBackofficeSdk from "src/lib/kepler/backoffice";
    import RouterTabHeaders from "components/structure/foundation/RouterTabHeaders";
    import Driver from "components/backoffice/Driver.vue";
    import Vehicle from "components/backoffice/Vehicle.vue";
    import BackofficeAttachment from "../../../components/backoffice/Attachment.vue";
    import VehicleDamage from "../../../components/backoffice/VehicleDamage.vue";

    export default {
        name: "ReportingController",
        components: {
            VehicleDamage,
            BackofficeAttachment,
            Vehicle,
            Driver,
            RouterTabHeaders,
            StatisticsCard4,
            KeplerBackofficeSdk
        },
        data() {
            return {
                lastUsed: null,

            }
        },
        created() {

        },
        methods: {},
        computed: {},
        props: ['item']
    }
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// Reporting.vue?4520a6a2